import React from "react";
import TransferNowContainer from "components/containers/TransferNowContainer/TransferNowContainer";


function TransferenceNowRoute(){
  return(
     <TransferNowContainer/>
  )
}

export default TransferenceNowRoute;
